import React from 'react'
import InlineTextEditor from '../../inline-editors/InlineTextEditor'
import { CellBaseProps, resolveOverrideContext, isFieldEditing, makeEditClickHandler, makeFieldSaveHandler, overrideEditableClass } from './types'

/**
 * Renders the Paint/Interior column cell with two editable rows:
 * paint date and interior date.
 */
export function PaintInteriorCell(props: CellBaseProps) {
  const { cellBorderClass, effectiveAircraft } = props
  const { isSoldWithTransaction, isEditable, transOverride, override } = resolveOverrideContext(props)

  const hasPaintDateOverride = isSoldWithTransaction
    ? (transOverride?.paint_date != null)
    : (override?.paint_date != null)
  const hasInteriorDateOverride = isSoldWithTransaction
    ? (transOverride?.interior_date != null)
    : (override?.interior_date != null)

  const currentPaintDate = isSoldWithTransaction
    ? (transOverride?.paint_date ?? effectiveAircraft.paint_date ?? null)
    : (override?.paint_date ?? effectiveAircraft.paint_date ?? null)
  const currentInteriorDate = isSoldWithTransaction
    ? (transOverride?.interior_date ?? effectiveAircraft.interior_date ?? null)
    : (override?.interior_date ?? effectiveAircraft.interior_date ?? null)

  const isEditingPaintDate = isFieldEditing(props, 'paint_date', isSoldWithTransaction)
  const isEditingInteriorDate = isFieldEditing(props, 'interior_date', isSoldWithTransaction)

  return (
    <td className={`px-2 py-2 text-sm text-gray-900 text-center ${cellBorderClass}`}>
      <div
        className={overrideEditableClass(hasPaintDateOverride, isEditable)}
        onClick={makeEditClickHandler(props, 'paint_date', isEditable, isSoldWithTransaction)}
      >
        {isEditingPaintDate ? (
          <InlineTextEditor
            value={currentPaintDate}
            fieldName="paint_date"
            inputType="number"
            min={1900}
            placeholder="YYYY"
            onSave={makeFieldSaveHandler(props, 'paint_date', isSoldWithTransaction)}
            onCancel={props.handleCancelEdit}
          />
        ) : (
          effectiveAircraft.paint_date ?? '-'
        )}
      </div>
      <div
        className={overrideEditableClass(hasInteriorDateOverride, isEditable)}
        onClick={makeEditClickHandler(props, 'interior_date', isEditable, isSoldWithTransaction)}
      >
        {isEditingInteriorDate ? (
          <InlineTextEditor
            value={currentInteriorDate}
            fieldName="interior_date"
            inputType="number"
            min={1900}
            placeholder="YYYY"
            onSave={makeFieldSaveHandler(props, 'interior_date', isSoldWithTransaction)}
            onCancel={props.handleCancelEdit}
          />
        ) : (
          effectiveAircraft.interior_date ?? '-'
        )}
      </div>
    </td>
  )
}

